module.exports = __webpack_public_path__ + "static/media/mo.5aaf3acb.svg";